export default "__VITE_ASSET__1dd8b53f__"